import { render } from "./FolderHomeIcon.vue?vue&type=template&id=0a27b2ec"
import script from "./FolderHomeIcon.vue?vue&type=script&lang=js"
export * from "./FolderHomeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__